import config from '../config';

export default class SummaryApi {

    /**
     * 获取 clip 的 AI 总结
     */
    static findByClipId = async (clipId) => {
        const url = `${config.url.api}/clips/${clipId}/summary`;
        const res = await fetch(url);
        const json = await res.json();
        if (!res.ok) {
            throw json;
        }
        return json;
    }

    /**
     * 检查 clip 是否有 AI 总结
     */
    static checkExists = async (clipId) => {
        const url = `${config.url.api}/clips/${clipId}/summary/exists`;
        const res = await fetch(url);
        const json = await res.json();
        if (!res.ok) {
            throw json;
        }
        return json;
    }

    /**
     * 根据关键词搜索 AI 总结（用于直播内容搜索）
     */
    static searchByKeyword = async (organizationId, keyword, page = 1, size = 20) => {
        const params = new URLSearchParams();
        params.append('keyword', keyword);
        params.append('page', page);
        params.append('size', size);
        
        const url = `${config.url.api}/organizations/${organizationId}/summaries/search?${params.toString()}`;
        const res = await fetch(url);
        const json = await res.json();
        if (!res.ok) {
            throw json;
        }
        return json;
    }
}
